import { Card, CardContent, Container, Typography } from '@mui/material'
import { grey } from '@mui/material/colors'
import { useEffect } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { showBannerState } from 'src/store/global/bannerShowState';
import IndexResendCode from 'src/Patient/resendCodeConfirmation/Index'
import { activeResendCodeState } from 'src/Patient/resendCodeConfirmation/state/atoms';
import IndexConfirmAccount from 'src/Patient/register/IndexConfirmAccount';
import useSEO from 'src/Hooks/useSEO';

const ResendCodeConfirmation = () => {

    const setShowBanner = useSetRecoilState(showBannerState);
    const activeResendCode = useRecoilValue(activeResendCodeState);
    useSEO({title: 'Enviar nuevo código de confirmación'});
    useEffect(() => {
        setShowBanner(false);

        return () => {
            setShowBanner(true);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <Container style={{ maxWidth: 650 }}>
        <Typography color={grey[700]} fontWeight={700} fontSize={24} pt={2}>
            ENVIAR NUEVO CÓDIGO DE CONFIRMACIÓN
        </Typography>
        <Typography color={grey[400]} fontWeight={700} fontSize={12} pb={2}>
            INGRESE SUS NUEVOS DATOS
        </Typography>

        <Card>
            <CardContent>
                { !activeResendCode &&  <IndexResendCode /> }
                { activeResendCode &&  <IndexConfirmAccount /> }
               
            </CardContent>
        </Card>
    </Container>
    )
}

export default ResendCodeConfirmation;